import styled from "styled-components";
import Header from "./sections/Header";
import RainfallMap from "./sections/rainfall/RainfallMap";

const RainfallPage = () => {
  return (
    <Container>
      <Header />
      <RainfallMap />
    </Container>
  );
};

export default RainfallPage;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "header"
    "map";
`;
